module.exports = __webpack_public_path__ + "img/side_seam_back_pocket_position.7840c8b1.png";